import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { FieldTypeConfig } from '@ngx-formly/core';
import { FieldType } from '@ngx-formly/material';
import { Store } from '@ngxs/store';
import { Zone } from 'app/models/dto/country-data.model';
import { CountryDataState } from 'app/store/country/country-data.state';
import { Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'zone-select',
  template: `
    <mat-select [formControl]="formControl" [(value)]="selected" data-cy="zone-select">
      <mat-select-trigger *ngIf="selected">{{ zoneAbbreviation(selected) }}</mat-select-trigger>
      <mat-option *ngFor="let zone of zones" [value]="zone.id" attr.data-cy="zone-option-{{zone.ISO3166Code}}">
        {{ zone.name }}
      </mat-option>
    </mat-select>
  `,
  standalone: false
})
export class ZoneSelectComponent extends FieldType<FieldTypeConfig> implements OnInit, OnDestroy {

  selected: string;
  zones: Zone[] | null;
  destroyed$ = new Subject<boolean>();

  constructor(
    private store: Store,
    private cdRef: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit() {
    this.store.select(CountryDataState.zonesByCountry).pipe(
      takeUntil(this.destroyed$),
      map(filterFn => filterFn(this.to.country.replace(/^[^A-Z]+/, '')))).subscribe(zones => {
        this.zones = zones;
        this.selected = this.formControl.value;
        this.cdRef.detectChanges();
      });
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  zoneAbbreviation(zoneId: number) {
    const matchingZone = this.zones?.find(z => z.id === zoneId);
    return matchingZone ? matchingZone.ISO3166Code : null;
  }
}
